/**
 * Copyright © 2025 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const JBP_AUDIT_COMPLIANCE_STATS_FRAGMENT = gql`
  fragment JBPComplianceStats on JBPComplianceStats {
    numCompliantRequirements
    numRequirements
    numCompliantAuditQuestions
    numAuditQuestions
  }
`
